import { render, staticRenderFns } from "./Gauge.vue?vue&type=template&id=0c1c5c50&scoped=true&"
import script from "./Gauge.vue?vue&type=script&lang=js&"
export * from "./Gauge.vue?vue&type=script&lang=js&"
import style0 from "./Gauge.vue?vue&type=style&index=0&id=0c1c5c50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1c5c50",
  null
  
)

export default component.exports